import { CONTACT, MARKETING_CONTACT_DEPRECATED } from '../../constants/UnitTypes';
import { IMMEDIATE_UPGRADE } from '../../constants/UsageBasedUpgradePolicies';
import { QUANTITY_PACK } from '../../constants/SkuTypes';
export const isMarketingContactsSku = ({
  skuMap,
  skuId
}) => {
  const _isMarketingContactsSku = quantityPack => {
    const {
      quantityUnit: {
        unitType
      },
      usageBasedUpgradePolicy
    } = quantityPack;
    return (unitType === CONTACT || unitType === MARKETING_CONTACT_DEPRECATED) && usageBasedUpgradePolicy === IMMEDIATE_UPGRADE;
  };

  const sku = skuMap[skuId];

  if (sku.skuType === QUANTITY_PACK) {
    return _isMarketingContactsSku(sku);
  } else {
    const {
      quantityPackDetails
    } = sku;
    return quantityPackDetails.some(quantityPack => _isMarketingContactsSku(quantityPack));
  }
};